import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';

import { RenderSelectField } from '../../form';
import { RsvpType } from '../../../manage/guestlist/GuestListTypes';

function removeFalseyValues(firstName, familyName, relationshipType) {
  if (firstName && familyName) {
    return `${firstName} ${familyName}`;
  }
  if (firstName) {
    return firstName;
  }
  if (familyName) {
    return familyName;
  }
  return relationshipType;
}

class RenderRSVP extends React.Component {
  constructor(props) {
    super(props);

    this.getGuestValue = this.getGuestValue.bind(this);
    this.formatName = this.formatName.bind(this);
    this.isAttending = this.isAttending.bind(this);
  }

  getGuestValue(name, index) {
    const { fields } = this.props;
    const guest = fields.get(index);
    return guest && guest[name];
  }

  formatName(index) {
    const firstName = this.getGuestValue('first_name', index) || null;
    const familyName = this.getGuestValue('family_name', index) || null;
    const relationshipType = this.getGuestValue('relationship_type', index);
    const nameUnknown = this.getGuestValue('name_unknown', index);
    const relationship = relationshipType === 'CHILD' ? 'Child' : 'Guest';

    return nameUnknown === true
      ? relationship
      : removeFalseyValues(firstName, familyName, relationship);
  }

  isAttending(index, eventId) {
    const eventInvitations = this.getGuestValue('event_invitations', index);
    const eventInvitation = eventInvitations && eventInvitations[eventId];
    return eventInvitation && eventInvitation.rsvp_type === 'ATTENDING';
  }

  render() {
    const { fields, mealOptions, eventId } = this.props;

    const hasMealOptions = mealOptions && mealOptions.length > 0;

    return (
      <div>
        <div className="row">
          <div className="col-xs-12 col-md-4">&nbsp;</div>
          <div className={`col-xs-12 col-md-4${!hasMealOptions ? ' col-md-offset-4' : ''}`}>
            <div className="form-label">RSVP</div>
          </div>
          {hasMealOptions && (
            <div className="col-xs-12 col-md-4">
              <div className="form-label">Meal Preference</div>
            </div>
          )}
        </div>
        {fields.map((guest, index) => (
          <div key={index} className="row">
            <div className="col-xs-12 col-md-4">
              <p className="form-control-static">{`${index + 1}. ${this.formatName(index)}`}</p>
            </div>
            <div className={`col-xs-12 col-md-4${!hasMealOptions ? ' col-md-offset-4' : ''}`}>
              <Field
                name={`${guest}.event_invitations[${eventId}].rsvp_type`}
                id="edit-guest-group-rsvp"
                options={RsvpType}
                component={RenderSelectField}
                hideEmpty
              />
            </div>
            {hasMealOptions && this.isAttending(index, eventId) && (
              <div className="col-xs-12 col-md-4">
                <Field
                  name={`${guest}.event_invitations[${eventId}].meal_option_id`}
                  id="edit-guest-group-meal-option"
                  options={mealOptions}
                  component={RenderSelectField}
                />
              </div>
            )}
            {hasMealOptions && !this.isAttending(index, eventId) && (
              <div className="col-xs-12 col-md-4">
                <div className="form-group meal-options-disabled">
                  <select className="form-control" disabled>
                    <option value="">Select...</option>
                  </select>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    );
  }
}

RenderRSVP.propTypes = {
  fields: PropTypes.shape({}),
  mealOptions: PropTypes.arrayOf(PropTypes.shape({})),
  eventId: PropTypes.number,
};

export default RenderRSVP;



// WEBPACK FOOTER //
// ./src/components/common/modals/EditGuestGroupWeddingsModal/RenderRSVP.jsx